import {useUserAuthContext} from "context/UserAuthContext";

export const useAuth = () => {
    const {userDetails} = useUserAuthContext();
    return userDetails?.user;
};


export const useGetAdmin = () => {
    const {userDetails: {user: {userId, roleId},},} = useUserAuthContext();

    return {isAdmin: roleId === "main", adminID: userId};
};
